/**
 * Wasserfall-Transform fuer den Prognose-Cashflow (C2.4b).
 *
 * Wandelt EBTDA → Tilgung → GD-Veraenderung in kumulative Schritte um und
 * haengt einen Netto-CF-Summenbalken an. Fuer einen Recharts-"Wasserfall" als
 * stacked BarChart: `base` ist das transparente Sockel-Segment, `bar` der
 * sichtbare Balken.
 *
 * null wird im Chart als 0 behandelt (ein Wasserfall braucht Zahlen) — die
 * Cashflow-TABELLE rendert null weiterhin als "—" (SCHEMA_MAPPING §5).
 */
import type { CashflowBlock } from '../types/snapshot';

export type WaterfallKind = 'start' | 'increase' | 'decrease' | 'total';

export interface WaterfallStep {
  label: string;
  /** Transparenter Sockel (untere Kante des sichtbaren Balkens). */
  base: number;
  /** Sichtbare Balkenhoehe (immer >= 0). */
  bar: number;
  /** Vorzeichenbehafteter Schrittwert (fuer Tooltip/Label). */
  value: number;
  kind: WaterfallKind;
}

const STEPS: { label: string; key: keyof CashflowBlock }[] = [
  { label: 'EBTDA', key: 'ebtda' },
  { label: 'Tilgung', key: 'tilgung' },
  { label: 'GD-Veränderung', key: 'gd_change' },
];

export function cashflowWaterfall(cf: CashflowBlock): WaterfallStep[] {
  const steps: WaterfallStep[] = [];
  let running = 0;
  STEPS.forEach(({ label, key }, i) => {
    const value = (cf[key] as number | null | undefined) ?? 0;
    const start = running;
    const end = running + value;
    steps.push({
      label,
      base: Math.min(start, end),
      bar: Math.abs(value),
      value,
      kind: i === 0 ? 'start' : value >= 0 ? 'increase' : 'decrease',
    });
    running = end;
  });
  steps.push({ label: 'Netto-CF', base: 0, bar: running, value: running, kind: 'total' });
  return steps;
}
